import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "ai-trainer" }
const _hoisted_3 = {
  key: 0,
  class: "ai-denied"
}
const _hoisted_4 = {
  class: "ai-hero",
  style: {"margin-bottom":"20px"}
}
const _hoisted_5 = {
  key: 0,
  class: "competitive-card",
  "aria-labelledby": "competitive-title"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "competitive-sub"
}
const _hoisted_9 = {
  key: 1,
  class: "competitive-card",
  "aria-labelledby": "usage-title"
}
const _hoisted_10 = { class: "ai-trainer-cols" }
const _hoisted_11 = { class: "ai-chat-panel" }
const _hoisted_12 = {
  class: "ai-chat-scroll",
  ref: "chatScroll"
}
const _hoisted_13 = {
  key: 0,
  class: "ai-chat-empty"
}
const _hoisted_14 = { class: "ai-msg-bubble" }
const _hoisted_15 = {
  key: 1,
  class: "ai-msg ai-msg-ai"
}
const _hoisted_16 = { class: "ai-chat-inputrow" }
const _hoisted_17 = { style: {"position":"relative","flex":"1","display":"flex"} }
const _hoisted_18 = { class: "ai-rules-panel" }
const _hoisted_19 = { class: "ai-rules-head" }
const _hoisted_20 = { class: "ai-learned-count" }
const _hoisted_21 = { class: "ai-rule-text" }
const _hoisted_22 = { class: "ai-learned-src" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "ai-rules-head" }
const _hoisted_26 = {
  key: 0,
  class: "ai-live-dot"
}
const _hoisted_27 = {
  key: 1,
  class: "ai-rules-empty"
}
const _hoisted_28 = { class: "ai-rule-num" }
const _hoisted_29 = ["onKeydown"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { style: {"display":"flex","gap":"8px","margin-top":"8px"} }
const _hoisted_34 = {
  key: 2,
  class: "ai-rules-note"
}
const _hoisted_35 = {
  key: 3,
  class: "ai-rules-empty"
}
const _hoisted_36 = ["onKeydown"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { style: {"display":"flex","gap":"8px","margin-top":"8px"} }
const _hoisted_41 = { style: {"display":"flex","justify-content":"flex-end","align-items":"center","gap":"10px","margin-top":"8px"} }
const _hoisted_42 = {
  key: 0,
  style: {"color":"#16a34a","font-size":"12.5px","font-weight":"600"}
}
const _hoisted_43 = { class: "ai-rule-text" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { style: {"display":"flex","gap":"8px","margin-top":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ai_dictation = _resolveComponent("ai-dictation")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, " "),
        _createElementVNode("div", { class: "page-bar-main" }, " ")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.denied)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[22] || (_cache[22] = _createElementVNode("span", {
                class: "ai-icon-badge",
                style: {"margin-bottom":"14px"}
              }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z" })
                ])
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("h2", null, "AI Training is restricted", -1)),
              _cache[24] || (_cache[24] = _createElementVNode("p", null, [
                _createTextVNode("Only your company's designated AI trainer can view or change the AI's training."),
                _createElementVNode("br"),
                _createTextVNode("The rules they set are applied automatically whenever you use the AI features.")
              ], -1)),
              _createElementVNode("div", {
                class: "ai-btn ai-btn-ghost",
                style: {"margin-top":"16px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/ai-hub')))
              }, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z" })
                ], -1),
                _createTextVNode(" Back to The Forge ", -1)
              ]))])
            ]))
          : (_ctx.loaded)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"ai-hero-left\" data-v-e54d260c><span class=\"ai-icon-badge\" data-v-e54d260c><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-e54d260c><path d=\"M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z\" data-v-e54d260c></path></svg></span><div data-v-e54d260c><div class=\"ai-hero-title\" data-v-e54d260c>Train Your AI <span class=\"ai-tag\" data-v-e54d260c>AI</span></div><p class=\"ai-hero-sub\" data-v-e54d260c> Tell the AI how you want your company&#39;s processes written — your standards, your style, your non-negotiables. It remembers everything here and applies it every time anyone on your team uses the AI. Only you can change this training. </p></div></div>", 1)),
                  _createElementVNode("div", {
                    class: "ai-btn ai-btn-ghost",
                    style: {"align-self":"flex-start","white-space":"nowrap"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/ai-hub')))
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z" })
                    ], -1),
                    _createTextVNode(" Back to The Forge ", -1)
                  ]))])
                ]),
                (_ctx.competitiveAllowed)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                      _createElementVNode("div", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "competitive-eyebrow" }, "IronBook market research", -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("h2", { id: "competitive-title" }, "Competitive analysis", -1)),
                        (_ctx.competitive)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.competitiveDate) + " · " + _toDisplayString(_ctx.competitive.changes) + " updates in this edition", 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.competitiveError ? 'The latest edition could not be checked.' : 'Weekly research, product comparisons and past editions.'), 1)),
                        (_ctx.competitive?.headline)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.competitive.headline), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_router_link, {
                        to: "/competitive-analysis",
                        class: "ai-btn competitive-link"
                      }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("View report ", -1),
                          _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.usageAllowed)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      _cache[31] || (_cache[31] = _createElementVNode("div", null, [
                        _createElementVNode("div", { class: "competitive-eyebrow" }, "IronBook operations"),
                        _createElementVNode("h2", { id: "usage-title" }, "IronBook usage"),
                        _createElementVNode("p", null, "How many people use IronBook in each company: logins, active users, content, sign-offs, meetings and AI use.")
                      ], -1)),
                      _createVNode(_component_router_link, {
                        to: "/usage",
                        class: "ai-btn competitive-link"
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("View usage ", -1),
                          _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (!_ctx.history.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[32] || (_cache[32] = [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, "Start training."),
                              _createTextVNode(" Try things like:")
                            ], -1),
                            _createElementVNode("p", { class: "ai-chat-hint" }, "\"Every process must end with an escalation contact section\"", -1),
                            _createElementVNode("p", { class: "ai-chat-hint" }, "\"Keep language professional — never use casual terms\"", -1),
                            _createElementVNode("p", { class: "ai-chat-hint" }, "\"Safety warnings always come before the step they apply to\"", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (m, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: _normalizeClass(["ai-msg", m.Role == 'user' ? 'ai-msg-user' : 'ai-msg-ai'])
                        }, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(m.Text), 1)
                        ], 2))
                      }), 128)),
                      (_ctx.thinking)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[33] || (_cache[33] = [
                            _createElementVNode("div", { class: "ai-msg-bubble ai-msg-thinking" }, [
                              _createElementVNode("span", { class: "ai-dot" }),
                              _createElementVNode("span", { class: "ai-dot" }),
                              _createElementVNode("span", { class: "ai-dot" })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 512),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draft) = $event)),
                          rows: "2",
                          placeholder: "Tell the AI how you want things done...",
                          style: {"padding-right":"44px"},
                          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.send()), ["exact","prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.draft]
                        ]),
                        _createVNode(_component_ai_dictation, {
                          style: {"position":"absolute","right":"10px","bottom":"10px"},
                          onText: _cache[4] || (_cache[4] = ($event: any) => (_ctx.draft = (_ctx.draft ? _ctx.draft.trim() + ' ' : '') + $event))
                        })
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["ai-btn", (!_ctx.draft.trim() || _ctx.thinking) ? 'disable-button' : '']),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.send()))
                      }, [...(_cache[34] || (_cache[34] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("path", { d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" })
                        ], -1),
                        _createTextVNode(" Send ", -1)
                      ]))], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.learned.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_19, [
                            _cache[35] || (_cache[35] = _createElementVNode("div", {
                              class: "ai-section-label",
                              style: {"margin":"0"}
                            }, "Learned from your team's feedback", -1)),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.learned.length) + " suggested", 1)
                          ]),
                          _cache[39] || (_cache[39] = _createElementVNode("div", {
                            class: "ai-rules-empty",
                            style: {"padding-top":"0","padding-bottom":"10px"}
                          }, " When anyone asks the AI to change a draft, it watches for standing preferences. Approve to make them permanent rules — or dismiss. ", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.learned, (s) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'l'+s.ID,
                              class: "ai-rule ai-rule-suggested"
                            }, [
                              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "ai-rule-num ai-rule-num-suggested" }, "?", -1)),
                              _createElementVNode("span", _hoisted_21, [
                                _createTextVNode(_toDisplayString(s.Rule) + " ", 1),
                                _createElementVNode("span", _hoisted_22, "from " + _toDisplayString(s.Source), 1)
                              ]),
                              _createElementVNode("span", {
                                class: "ai-rule-del",
                                style: {"color":"#16a34a"},
                                title: "Approve — becomes a live rule",
                                onClick: ($event: any) => (_ctx.resolveLearned(s, 'approve'))
                              }, [...(_cache[36] || (_cache[36] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                                ], -1)
                              ]))], 8, _hoisted_23),
                              _createElementVNode("span", {
                                class: "ai-rule-del",
                                title: "Dismiss",
                                onClick: ($event: any) => (_ctx.resolveLearned(s, 'dismiss'))
                              }, [...(_cache[37] || (_cache[37] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
                                ], -1)
                              ]))], 8, _hoisted_24)
                            ]))
                          }), 128)),
                          _cache[40] || (_cache[40] = _createElementVNode("div", { style: {"height":"14px"} }, null, -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[41] || (_cache[41] = _createElementVNode("div", {
                        class: "ai-section-label",
                        style: {"margin":"0"}
                      }, "Active training rules", -1)),
                      (_ctx.rules.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "● live for all staff"))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.rules.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, " No rules yet — everything you teach the AI in the chat shows up here. "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'r'+i,
                        class: "ai-rule"
                      }, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(i + 1), 1),
                        (_ctx.editing == 'rules:'+i)
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editText) = $event)),
                              class: "ai-edit-input",
                              rows: "2",
                              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.saveEdit('rules', i)), ["exact","prevent"]), ["enter"])
                            }, null, 40, _hoisted_29)), [
                              [_vModelText, _ctx.editText]
                            ])
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "ai-rule-text",
                              title: "Click to edit",
                              style: {"cursor":"text"},
                              onClick: ($event: any) => (_ctx.startEdit('rules', i, rule))
                            }, _toDisplayString(rule), 9, _hoisted_30)),
                        (_ctx.editing == 'rules:'+i)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: "ai-rule-del",
                              style: {"color":"#16a34a"},
                              title: "Save",
                              onClick: ($event: any) => (_ctx.saveEdit('rules', i))
                            }, [...(_cache[42] || (_cache[42] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                              ], -1)
                            ]))], 8, _hoisted_31))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              class: "ai-rule-del",
                              title: "Remove rule",
                              onClick: ($event: any) => (_ctx.editList('rules', 'delete', i))
                            }, [...(_cache[43] || (_cache[43] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "13",
                                height: "13",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
                              ], -1)
                            ]))], 8, _hoisted_32))
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newRule) = $event)),
                        type: "text",
                        placeholder: "Type a rule directly...",
                        style: {"flex":"1","margin":"0"},
                        onKeydown: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.addItem('rules')), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.newRule]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["ai-btn ai-btn-ghost", !_ctx.newRule.trim() ? 'disable-button' : '']),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addItem('rules')))
                      }, "Add", 2)
                    ]),
                    (_ctx.rules.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, " These rules are enforced on every AI-generated or AI-improved process, for every user. Click a rule to edit it. "))
                      : _createCommentVNode("", true),
                    _cache[48] || (_cache[48] = _createElementVNode("div", {
                      class: "ai-rules-head",
                      style: {"margin-top":"22px"}
                    }, [
                      _createElementVNode("div", {
                        class: "ai-section-label",
                        style: {"margin":"0"}
                      }, "Company knowledge")
                    ], -1)),
                    (!_ctx.knowledge.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, " Facts the AI should know — products, equipment, systems, roles, terminology. Learned from your chats, or add them directly. "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowledge, (fact, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'k'+i,
                        class: "ai-rule"
                      }, [
                        _cache[46] || (_cache[46] = _createElementVNode("span", {
                          class: "ai-rule-num",
                          style: {"background":"white","color":"var(--ai-accent)","border":"1px solid var(--ai-border-soft)"}
                        }, "ⓘ", -1)),
                        (_ctx.editing == 'knowledge:'+i)
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editText) = $event)),
                              class: "ai-edit-input",
                              rows: "2",
                              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.saveEdit('knowledge', i)), ["exact","prevent"]), ["enter"])
                            }, null, 40, _hoisted_36)), [
                              [_vModelText, _ctx.editText]
                            ])
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "ai-rule-text",
                              title: "Click to edit",
                              style: {"cursor":"text"},
                              onClick: ($event: any) => (_ctx.startEdit('knowledge', i, fact))
                            }, _toDisplayString(fact), 9, _hoisted_37)),
                        (_ctx.editing == 'knowledge:'+i)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: "ai-rule-del",
                              style: {"color":"#16a34a"},
                              title: "Save",
                              onClick: ($event: any) => (_ctx.saveEdit('knowledge', i))
                            }, [...(_cache[44] || (_cache[44] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                              ], -1)
                            ]))], 8, _hoisted_38))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              class: "ai-rule-del",
                              title: "Remove",
                              onClick: ($event: any) => (_ctx.editList('knowledge', 'delete', i))
                            }, [...(_cache[45] || (_cache[45] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "13",
                                height: "13",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
                              ], -1)
                            ]))], 8, _hoisted_39))
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newFact) = $event)),
                        type: "text",
                        placeholder: "Add a fact the AI should know...",
                        style: {"flex":"1","margin":"0"},
                        onKeydown: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.addItem('knowledge')), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.newFact]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["ai-btn ai-btn-ghost", !_ctx.newFact.trim() ? 'disable-button' : '']),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addItem('knowledge')))
                      }, "Add", 2)
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("div", {
                      class: "ai-rules-head",
                      style: {"margin-top":"22px"}
                    }, [
                      _createElementVNode("div", {
                        class: "ai-section-label",
                        style: {"margin":"0"}
                      }, "Style guide")
                    ], -1)),
                    _cache[50] || (_cache[50] = _createElementVNode("div", {
                      class: "ai-rules-empty",
                      style: {"padding-bottom":"8px"}
                    }, " How your processes should be written — tone, voice, wording, structure. The AI follows this every time it writes, improves or audits a process. ", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.style) = $event)),
                      class: "ai-style-input",
                      rows: "6",
                      placeholder: "e.g. Write in third person — never 'I'. Keep steps short and direct. Say 'team member', not 'employee'. Imperial units only. Headers: Overview first, then Step 1, Step 2..."
                    }, null, 512), [
                      [_vModelText, _ctx.style]
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      (_ctx.styleSaved)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Saved"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["ai-btn ai-btn-ghost", _ctx.style == _ctx.savedStyle ? 'disable-button' : '']),
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveStyle()))
                      }, "Save Style Guide", 2)
                    ]),
                    _cache[51] || (_cache[51] = _createElementVNode("div", {
                      class: "ai-rules-head",
                      style: {"margin-top":"22px"}
                    }, [
                      _createElementVNode("div", {
                        class: "ai-section-label",
                        style: {"margin":"0"}
                      }, "Who can train the AI")
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainers, (t) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: t.ID,
                        class: "ai-rule",
                        style: {"align-items":"center"}
                      }, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(t.Email), 1),
                        (_ctx.trainers.length > 1)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "ai-rule-del",
                              title: "Remove trainer",
                              onClick: ($event: any) => (_ctx.removeTrainerCheck(t))
                            }, [...(_cache[47] || (_cache[47] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "13",
                                height: "13",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
                              ], -1)
                            ]))], 8, _hoisted_44))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_45, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newTrainerEmail) = $event)),
                        type: "email",
                        placeholder: "email@company.com",
                        style: {"flex":"1","margin":"0"},
                        onKeydown: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.addTrainer()), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.newTrainerEmail]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["ai-btn ai-btn-ghost", !_ctx.newTrainerEmail.trim() ? 'disable-button' : '']),
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addTrainer()))
                      }, "Add", 2)
                    ]),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "ai-rules-note" }, "Trainers can change the AI's rules and manage this list. Everyone else can use the AI but not retrain it.", -1))
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
      ]),
      (_ctx.showTrainerToRemoveConfirm)
        ? (_openBlock(), _createBlock(_component_confirm_delete, {
            key: 0,
            onConfirm: _cache[19] || (_cache[19] = ($event: any) => (_ctx.removeTrainer())),
            onCancel: _cache[20] || (_cache[20] = () => { _ctx.showTrainerToRemoveConfirm = false; }),
            msg: _ctx.trainerToRemoveMsg
          }, null, 8, ["msg"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}